import React from 'react';
import { Alert } from '@ver-uds/uswds-react';

export type ErrorBarProps = {
  errorMessage: string | undefined;
};

const ErrorBar = ({ errorMessage }: ErrorBarProps): JSX.Element | null => {
  if (errorMessage) {
    return (
      <Alert status="error" slim>
        <Alert.Text>{errorMessage}</Alert.Text>
      </Alert>
    );
  }
  return null;
};

export default ErrorBar;
